import React from "react";
import { fileTypes } from "../../../consts/consts";
import UploadFile, { acceptsFile, FileDropTarget } from "../../UploadFile";

export default class UploadFiles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMaxFiles: 1,
            uploadManually: false,
        };

        this.slots = {};

        this.increaseMaxFiles = this.increaseMaxFiles.bind(this);
        this.dropFiles = this.dropFiles.bind(this);
        this.handleSlotChange = this.handleSlotChange.bind(this);

    }

    componentDidMount() {
        const {items, data, initialFilesAmount} = this.props;
        let fileCount = initialFilesAmount ? initialFilesAmount : items.reduce((count, item) => data[item.name] ? ++count : count, 0)
        this.setState({currentMaxFiles: fileCount || 1})
    }

    increaseMaxFiles() {
        let currentMaxFiles = this.state.currentMaxFiles;
        const maxFiles = this.props.maxFilesAmount;

        if (currentMaxFiles + 1 <= maxFiles)
            this.setState({currentMaxFiles: currentMaxFiles + 1});
    }

    dropFiles(files, targetName) {
        const {items, data} = this.props;
        const fileType = this.props.fileType ? this.props.fileType : fileTypes.Document;
        const currentMaxFiles = this.state.currentMaxFiles;
        const accepted = files.filter(file => acceptsFile(file, fileType));

        const free = items.filter((item, index) => index < currentMaxFiles
            ? this.slots[item.name] && this.slots[item.name].isEmpty()
            : !data[item.name]);
        const targets = [
            ...free.filter(item => item.name === targetName),
            ...free.filter(item => item.name !== targetName),
        ].slice(0, accepted.length);

        if (!targets.length) return;

        const lastIndex = Math.max(...targets.map(item => items.indexOf(item)));
        this.setState({currentMaxFiles: Math.max(currentMaxFiles, lastIndex + 1)}, () => {
            targets.forEach((item, i) => this.slots[item.name].selectFile(accepted[i]));
        });
    }

    handleSlotChange(key, value) {
        const {items, data, handleChangeFile, handleChangeFiles, collapseOnRemove} = this.props;
        if (value || !collapseOnRemove) return handleChangeFile(key, value);

        const index = items.findIndex(item => item.name === key);
        const changes = {};
        items.slice(index).forEach((item, i) => {
            const next = items[index + i + 1];
            changes[item.name] = next && data[next.name] ? data[next.name] : null;
        });

        this.setState(({currentMaxFiles}) => ({currentMaxFiles: Math.max(1, currentMaxFiles - 1)}));
        return handleChangeFiles(changes);
    }

    render() {
        const {data, items, viewMode, deleted, disabled, classNames, maxFilesAmount, canUploadManually, handleChangeInput, droppable} = this.props;
        const currentMaxFiles = this.state.currentMaxFiles;
        const uploadManually = this.state.uploadManually;
        const fileType = this.props.fileType ? this.props.fileType : fileTypes.Document;

        return (
            <React.Fragment>
                {
                    items.map((item,index) => {
                        if (index < currentMaxFiles)
                            return (
                                <UploadFile
                                    ref={slot => { this.slots[item.name] = slot; }}
                                    data={data}
                                    className={classNames}
                                    key={item.name}
                                    label={item.label}
                                    name={item.name}
                                    link={data[item.name]}
                                    disabled={disabled}
                                    deleted={deleted}
                                    viewMode={viewMode}
                                    handleChange={this.handleSlotChange}
                                    fileType={fileType}
                                    uploadManually={uploadManually}
                                    handleChangeInput={handleChangeInput}
                                    droppable={droppable}
                                    onDropFiles={droppable ? this.dropFiles : undefined}
                                />
                            );
                    })
                }
                {
                    currentMaxFiles < maxFilesAmount && !viewMode &&
                    <FileDropTarget enabled={!!droppable && !disabled} onFiles={this.dropFiles}>
                        <button
                            type='button'
                            className='button-new positive'
                            onClick={this.increaseMaxFiles}>
                            Add {fileType === fileTypes.Photo ? 'photo' : 'file'}
                        </button>
                    </FileDropTarget>
                }
                {
                    !viewMode && canUploadManually &&
                    <button
                        type='button'
                        className='button-new positive upload-type'
                        onClick={() => this.setState({uploadManually: !this.state.uploadManually})}>
                        Upload {uploadManually ? 'File' : 'Manually'}
                    </button>
                }
            </React.Fragment>
        );
    }
}

